<script setup lang="ts">
import Notification from '@/components/notifications/Notification.vue';
import { NotificationMessage } from '@/components/notifications/types';
import { useField } from 'vee-validate';
import { computed, toRef, watch } from 'vue';

const { name } = defineProps<{
  name: string;
}>();

// Own path state so backend errors on `combinations` are not hoisted onto `combinationTable`.
// Must only be mounted when the table exists, otherwise registering creates an empty parent object.
const { errorMessage, meta, validate, setErrors } = useField(toRef(() => name));

// A later silent form validation (e.g. BCC evaluation fields (un)mounting) supersedes the run that
// would update the message, leaving only `meta.valid` in sync
watch(
  () => meta.valid,
  (valid) => {
    if (valid) {
      setErrors([]);
    } else {
      validate();
    }
  },
  { immediate: true },
);

const notification = computed<NotificationMessage | undefined>(() =>
  errorMessage.value ? { type: 'error', closable: false, message: errorMessage.value } : undefined,
);
</script>

<template>
  <Notification v-if="notification" :value="notification" class="mt-5 mb-4 pa-4" />
</template>
